<template>
  <div class="cbs-bank-account-container">
    <!-- 筛选条件区域 -->
    <el-card class="filter-card">
      <el-form :inline="true" size="small">
        <el-form-item label="银行类型">
          <el-select
            v-model="queryParams.bankTypeList"
            multiple
            filterable
            clearable
            placeholder="请选择银行类型"
            style="width: 200px;">
            <el-option
              v-for="item in bankTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="银行账号">
          <el-input
            v-model="queryParams.accountNo"
            placeholder="请输入银行账号"
            clearable
            style="width: 200px;">
          </el-input>
        </el-form-item>

        <el-form-item label="机构">
          <el-select
            v-model="queryParams.companyCode"
            filterable
            clearable
            placeholder="请选择机构"
            style="width: 200px;">
            <el-option
              v-for="item in companyOptions"
              :key="item.company_code"
              :label="item.company_name"
              :value="item.company_code">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchAccountList" :loading="loading">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 数据表格区域 -->
    <el-card class="table-card">
      <el-table
        :data="tableData"
        border
        stripe
        v-loading="loading"
        height="calc(100vh - 280px)"
        style="width: 100%">

        <el-table-column prop="bank_account_no" label="银行账号" width="180"></el-table-column>
        <el-table-column prop="bank_account_name" label="账户名称" width="250"></el-table-column>
        <el-table-column prop="bank_address" label="开户行" width="250" show-overflow-tooltip></el-table-column>
        <el-table-column prop="bank_type" label="银行类型"></el-table-column>
        <el-table-column prop="bank_state" label="账户状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.bank_state === 1 ? 'success' : 'info'" size="small">
              {{ scope.row.bank_state === 1 ? '正常' : '撤销' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="company_code" label="单位编码" width="80"></el-table-column>
        <el-table-column prop="company_name" label="单位名称" width="220" show-overflow-tooltip></el-table-column>
        <el-table-column prop="use_type" label="用途类型" width="100">
          <template slot-scope="scope">
            {{ getUseTypeText(scope.row.use_type) }}
          </template>
        </el-table-column>
        <el-table-column label="关联项目" width="100">
          <template slot-scope="scope">
            {{ getPindexCount(scope.row.pindex_ids) }}
          </template>
        </el-table-column>

        <!-- 操作列 -->
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="openEditDialog(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <el-pagination
        @current-change="handlePageChange"
        :current-page.sync="pagination.page"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        layout="total, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>

    <!-- 编辑对话框 -->
    <el-dialog
      title="编辑银行帐号"
      :visible.sync="editDialogVisible"
      width="70%"
      @close="closeDialog">
      <el-form
        :model="editForm"
        ref="editForm"
        label-width="120px"
        v-loading="formLoading">

        <el-form-item label="银行账号">
          <el-input v-model="editForm.bank_account_no" disabled></el-input>
        </el-form-item>

        <el-form-item label="账户名称">
          <el-input v-model="editForm.bank_account_name" disabled></el-input>
        </el-form-item>

        <el-form-item label="用途类型" prop="use_type">
          <el-select
            v-model="editForm.use_type"
            multiple
            placeholder="请选择用途类型"
            style="width: 100%">
            <el-option label="转账收入" :value="1"></el-option>
            <el-option label="运营支出" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="关联项目">
          <el-transfer
            v-model="selectedProjects"
            :data="allProjects"
            :titles="['可选项目', '已选项目']"
            filterable
            filter-placeholder="搜索项目"
            :props="{
              key: 'id',
              label: 'name'
            }"
            style="display: block; width: 100%;">
            <span slot="left-footer" style="display: inline-block; width: 100%; text-align: center; padding: 8px 0; color: #909399; font-size: 12px;">共 {{ allProjects.length }} 个项目</span>
          </el-transfer>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="formLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CbsBankAccount',
  data() {
    return {
      // 查询参数
      queryParams: {
        bankTypeList: [],
        accountNo: '',
        companyCode: '' // 改为公司编码
      },
      bankTypeOptions: [], // 银行类型选项列表
      companyOptions: [], // 公司选项列表

      // 表格数据
      tableData: [],
      loading: false,

      // 分页
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },

      // 编辑对话框
      editDialogVisible: false,
      formLoading: false,
      editForm: {
        id: null,
        bank_account_no: '',
        bank_account_name: '',
        use_type: [], // 改为数组，支持多选
        pindex_ids: ''
      },
      selectedProjects: [], // 已选项目ID数组
      allProjects: [] // 所有可选项目列表
    };
  },

  created() {
    // 加载银行类型列表
    this.loadBankTypeList();
    // 加载公司列表
    this.loadCompanyList();
    // 自动查询
    this.searchAccountList();
  },

  methods: {
    // 加载银行类型列表
    loadBankTypeList() {
      this.$myhttp.post('admin/cbsBankType', {}, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        if (res.data.code === 200) {
          this.bankTypeOptions = res.data.data || [];
        } else {
          console.error('加载银行类型列表失败:', res.data.message);
        }
      }).catch(err => {
        console.error('加载银行类型列表异常:', err);
      });
    },

    // 加载公司列表
    loadCompanyList() {
      this.$myhttp.get('admin/cbsBankAccount/companyList', {
        'Content-Type': 'application/json'
      }).then(res => {
        if (res.data.code === 200) {
          this.companyOptions = res.data.data || [];
        } else {
          console.error('加载公司列表失败:', res.data.message);
        }
      }).catch(err => {
        console.error('加载公司列表异常:', err);
      });
    },

    // 查询账户列表
    searchAccountList() {
      this.loading = true;
      const params = {
        bankTypeList: this.queryParams.bankTypeList.length > 0 ? this.queryParams.bankTypeList : undefined,
        accountNo: this.queryParams.accountNo || undefined,
        unitCodeList: this.queryParams.companyCode ? [this.queryParams.companyCode] : undefined, // 转换为数组
        pageNum: this.pagination.page,
        pageSize: this.pagination.pageSize
      };

      this.$myhttp.post('admin/cbsBankAccount/list', params, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        this.loading = false;
        if (res.data.code === 200) {
          this.tableData = res.data.data.list || [];
          this.pagination.total = res.data.data.total || 0;

          if (this.tableData.length === 0) {
            this.$message.info('暂无数据');
          }
        } else {
          this.$message.error(res.data.message || '查询失败');
        }
      }).catch(err => {
        this.loading = false;
        this.$message.error('请求异常');
        console.error(err);
      });
    },

    // 重置查询
    resetQuery() {
      this.queryParams = {
        bankTypeList: [],
        accountNo: '',
        companyCode: ''
      };
      this.pagination.page = 1;
      this.searchAccountList();
    },

    // 分页切换
    handlePageChange(page) {
      this.pagination.page = page;
      this.searchAccountList();
    },

    // 打开编辑对话框
    openEditDialog(row) {
      this.editForm = {
        id: row.id,
        bank_account_no: row.bank_account_no,
        bank_account_name: row.bank_account_name,
        use_type: row.use_type ? [parseInt(row.use_type)] : [], // 转换为数组
        pindex_ids: row.pindex_ids || ''
      };

      // 格式化已选项目
      if (row.pindex_ids) {
        this.selectedProjects = row.pindex_ids.split(',').map(id => parseInt(id));
      } else {
        this.selectedProjects = [];
      }

      // 加载项目列表
      this.loadProjectList();

      this.editDialogVisible = true;
    },

    // 加载项目列表
    loadProjectList() {
      this.$myhttp.get('admin/common/pindex', {
        'Content-Type': 'application/json'
      }).then(res => {
        if (res.data.code === 200) {
          this.allProjects = res.data.data || [];
        } else {
          this.$message.error(res.data.message || '加载项目列表失败');
        }
      }).catch(err => {
        this.$message.error('加载项目列表异常');
        console.error(err);
      });
    },

    // 提交表单
    submitForm() {
      if (!this.editForm.use_type || this.editForm.use_type.length === 0) {
        this.$message.warning('请选择用途类型');
        return;
      }

      this.formLoading = true;

      // 合并设置用途类型和关联项目
      const pindexIdsStr = this.selectedProjects.length > 0
        ? this.selectedProjects.join(',')
        : '';

      // use_type 从数组转换为逗号分隔的字符串
      const useTypeStr = this.editForm.use_type.join(',');

      this.$myhttp.post('admin/cbsBankAccount/save', {
        id: this.editForm.id,
        use_type: useTypeStr,
        pindex_ids: pindexIdsStr
      }, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        this.formLoading = false;
        if (res.data.code === 200) {
          this.$message.success('保存成功');
          this.editDialogVisible = false;
          this.searchAccountList(); // 刷新列表
        } else {
          this.$message.error(res.data.message || '保存失败');
        }
      }).catch(err => {
        this.formLoading = false;
        this.$message.error(err.message || '保存失败');
        console.error(err);
      });
    },

    // 关闭对话框
    closeDialog() {
      // 清空表单数据
      this.editForm = {
        id: null,
        bank_account_no: '',
        bank_account_name: '',
        use_type: [], // 改为数组
        pindex_ids: ''
      };
      this.selectedProjects = [];
      this.allProjects = [];

      // 清除表单验证
      this.$nextTick(() => {
        if (this.$refs.editForm) {
          this.$refs.editForm.clearValidate();
        }
      });
    },

    // 获取用途类型文本
    getUseTypeText(useType) {
      const map = {
        1: '转账收入',
        2: '运营支出'
      };
      if(useType === '' || useType == null){
        return '';
      }
      let useTypeArr = useType.split(',');
      return useTypeArr.map(type => map[type]).join(',');
    },

    // 计算关联项目数量
    getPindexCount(pindexIds) {
      if (!pindexIds) return 0;
      return pindexIds.split(',').length;
    }
  }
};
</script>

<style scoped>
.cbs-bank-account-container {
  padding: 20px;
}

.filter-card {
  margin-bottom: 20px;
}

.table-card {
  min-height: calc(100vh - 280px);
}

.dialog-footer {
  text-align: right;
}

/* 穿梭框样式 */
::v-deep .el-transfer-panel {
  width: 45%;
}

::v-deep .el-transfer__buttons {
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/CbsBankAccount.vue